import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  parceiro: {
    loading: false,
    error: false,
    paleta: {},
    logo: []
  },
};

const WhitelabelSlice = createSlice({
  name: 'whitelabel',
  initialState,
  reducers: {
    obterDadosRequest: (state) => {
      state.parceiro.loading = true;
      state.parceiro.error = null;
    },
    obterDadosSuccess: (state, action) => {
      // Normaliza paleta como objeto (nunca string vazia) e logo como
      // array (nunca string vazia) para que os fallbacks Homefin do
      // ThemeOption e dos componentes Logo* funcionem corretamente
      // quando o parceiro nao tem whitelabel ou nao existe.
      const data = action.payload?.response?.data ?? {};
      state.parceiro.loading = false;
      state.parceiro.error = false;
      state.parceiro.paleta =
        data.paleta && typeof data.paleta === 'object' ? data.paleta : {};
      state.parceiro.logo = Array.isArray(data.logo) ? data.logo : [];
    },
    obterDadosFailure: (state, action) => {
      // Em failure tambem reseta para defaults Homefin (objeto vazio +
      // array vazio) para garantir que os fallbacks sempre funcionem.
      state.parceiro.loading = false;
      state.parceiro.error = action.payload;
      state.parceiro.paleta = {};
      state.parceiro.logo = [];
    },
  }
});

export const {
  obterDadosRequest,
  obterDadosSuccess,
  obterDadosFailure,
} = WhitelabelSlice.actions;

export default WhitelabelSlice.reducer;
